import React from 'react';

type SpinnerProps = {
  size?: string;
  strokeWidth?: string;
  color?: string;
  duration?: string;
  repeatCount?: string;
  style?: React.CSSProperties | null;
};

function Spinner({
  size = '26',
  strokeWidth = '3',
  color = '#fff',
  duration = '0.4',
  repeatCount = 'indefinite',
  style = null,
}: SpinnerProps) {
  return (
    <div
      className="spinner"
      data-testid="spinner"
      style={style || { display: 'inline-block', width: `${size}px`, height: `${size}px` }}
    >
      <svg
        className="Spinner"
        width={size}
        height={size}
        viewBox="-1 -1 40 40"
        stroke={color}
        style={{ padding: strokeWidth }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1 1)" strokeWidth={strokeWidth}>
            <circle strokeOpacity=".25" cx="18" cy="18" r="18" />
            <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(211.717 18 18)">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur={`${duration}s`}
                repeatCount={repeatCount}
              />
            </path>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default Spinner;
